import { createPinia } from 'pinia'
import { useI18n } from 'vue-i18n'
import { markRaw } from 'vue'
import router from '@/router'

const pinia = createPinia()

const piniaI18nPlugin = ({ app }) => {
  const t = app.config.globalProperties.$t
  const locale = app.config.globalProperties.$i18n?.locale

  return {
    t,
    locale,
  }
}

pinia.use(piniaI18nPlugin)
pinia.use(({ store }) => {
  store.router = markRaw(router)
})

export { useAppStore } from './app.js'
export { useAuthStore } from './auth.js'
export { useCurrentGameStore } from './game/currentGame.js'
export { useAllGamesStore } from './game/allGames.js'
export { useInstitutionStore } from './institution.js'
export { useQuestionStore } from './question/question.js'
export { useStatisticsStore } from './statistics.js'
export { useAllQuestionStore } from './question/allQuestion.js'
export { useCategoriesStore } from './categories.js'
export { useMediaStore } from './media.js'
export { useUsersStore } from './user.js'
export { useSubscriptionStore } from './subscription.js'

export default pinia
